const Select = ({ value, name, onChange, options, label, ...props }) => {
  return (
    <div className="w-full">
      <label className="mb-2 block text-black dark:text-white">{label}</label>
      <div className="relative z-20 bg-white dark:bg-form-input">
        <select
          value={`${value}`}
          onChange={onChange}
          name={name}
          {...props}
          className={`relative z-20 w-full appearance-none rounded border border-stroke bg-transparent py-3 px-12 outline-none transition focus:border-primary active:border-primary dark:border-form-strokedark dark:bg-form-input`}
        >
          {options.map((x, index) => (
            <option
              value={`${x.value}`}
              className="text-body dark:text-bodydark"
              key={index}
            >
              {x.name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Select;
